/**
 * API version enum
 */
export enum ApiVersionEnum {
	/**
	 * Version 1
	 */
	V1 = 'v1',
}
